import { render, staticRenderFns } from "./DocumentShareModal.vue?vue&type=template&id=039f63ac&scoped=true"
import script from "./DocumentShareModal.vue?vue&type=script&lang=js"
export * from "./DocumentShareModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentShareModal.vue?vue&type=style&index=0&id=039f63ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f63ac",
  null
  
)

export default component.exports